module.exports = __webpack_public_path__ + "static/img/8.a156a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-en/8.jpg
// module id = C1ol
// module chunks = 1